<template>
  <div class="gender-distribution-graph">
    <div class="graph-row">
      <p>남성</p>
      <div class="graph-container">
        <el-popover
          placement="top-start"
          title="남성"
          width="90px"
          trigger="hover"
          :content="maleShare + '%'"
        >
          <div
            slot="reference"
            class="graph-bar"
            :style="maleGraphBarStyle"
          >
            <div class="graph-value">
              {{ data.male }}명
            </div>
          </div>
        </el-popover>
      </div>
    </div>
    <div class="graph-row">
      <p>여성</p>
      <div class="graph-container">
        <el-popover
          placement="top-start"
          title="여성"
          width="90px"
          trigger="hover"
          :content="femaleShare + '%'"
        >
          <div
            slot="reference"
            class="graph-bar"
            :style="femaleGraphBarStyle"
          >
            <div class="graph-value">
              {{ data.female }}명
            </div>
          </div>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	name: "GenderDistributionGraph",
	props: ["data"],
	data() {
		return {
			maleGraphBarStyle: {
				// width: '0'
			},
			femaleGraphBarStyle: {
				// width: '0'
			},
		};
	},
	computed: {
		femaleShare() {
			if (this.data.male === 0 && this.data.female === 0) {
				return 0;
			}

			return Math.round(
				(100 * this.data.female) / (this.data.male + this.data.female)
			);
		},
		maleShare() {
			if (this.data.male === 0 && this.data.female === 0) {
				return 0;
			}

			return Math.round(
				(100 * this.data.male) / (this.data.male + this.data.female)
			);
		},
	},
	watch: {
		data: {
			deep: true,
			handler(data) {
				if (data.male === 0 && data.female === 0) {
					this.maleGraphBarStyle.width = "0";
					this.femaleGraphBarStyle.width = "0";
				}

				if (data.male > data.female) {
					this.maleGraphBarStyle.width = "100%";
					this.femaleGraphBarStyle.width = `${this.femaleShare}%`;
				}

				if (data.male < data.female) {
					this.maleGraphBarStyle.width = `${this.maleShare}%`;
					this.femaleGraphBarStyle.width = "100%";
				}

				if (data.male === data.female) {
					this.maleGraphBarStyle.width = "100%";
					this.femaleGraphBarStyle.width = "100%";
				}
			},
		},
	},
};
</script>

<style lang="scss">
.gender-distribution-graph {
	padding: 44px 24px;

	.graph-row {
		p {
			display: inline-block;
			width: 50px;
			text-align: left;
			font-size: 15px;
			color: #4a4a4a;
			letter-spacing: -0.62px;
		}

		div {
			display: inline-block;
		}

		.graph-container {
			width: calc(100% - 70px);

			.graph-bar {
				position: relative;
				display: inline-block;
				height: 10px;
				border-radius: 6px;
				background-color: #9b9b9b;
				margin-right: 10px;
			}

			.graph-value {
				position: absolute;
				right: -22px;
				top: 1px;
				display: inline-block;
				font-size: 12px;
				font-weight: 500;
				letter-spacing: -0.5px;
				color: #9b9b9b;
				line-height: 10px;
				height: 10px;
			}
		}
	}
}
</style>
